<div class="gt-filter-container submission-list-filter">
  <div class="col refresh-col">
    <i class="fa fa-refresh gt-refresh"
       title="Refresh Data"
       (click)="refresh()"></i>
  </div>

  <div class="col">
    <select name="taxYear"
            [ngModel]="selectedTaxYearValue"
            (ngModelChange)="onTaxYearChange($event)">
      @for (item of taxYears; track $index) {
<option [ngValue]="item.value">{{ item.label }}</option>
}
    </select>
  </div>

  <div class="col">
    <select name="type"
            [ngModel]="submissionType"
            (ngModelChange)="onTypeChange($event)">
      <option value="state">State</option>
      <option value="federal">Federal</option>
    </select>
  </div>

  <div class="col">
    <button type="button" class="btn btn-xs btn-success" (click)="refresh()">Filter</button>
    @if (!filterMatch) {
<span class="filter-warning">
      <i class="fa fa-exclamation-triangle"></i>
      Warning! Filters do not match with the current cached data
    </span>
}
  </div>
</div>
